import * as React from "react";
import { gql, graphql, ChildProps } from "react-apollo";
import { Button, TextField, Typography } from "@material-ui/core";
import { RouteComponentProps, withRouter } from "react-router";
import withDialog, { DialogProp } from "app/utils/withDialog";
import handleMutationError from "app/utils/handleMutationError";

type MutationResult = {
  ticket_event_request_changes: {
    id: string;
    name: string;
    status: string;
    external_reference: string;
    approval_comments: string[];
  };
};

type Props = ChildProps<
  {
    id: string;
    reloadData: () => void;
    redirectPath: string;
  } & DialogProp &
    RouteComponentProps,
  MutationResult
>;

class TicketEventRequestChangesButton extends React.Component<Props> {
  approvalComments = "";

  onApprovalCommentsChange(nextApprovalComments: string) {
    this.approvalComments = nextApprovalComments;
  }

  requestChanges() {
    this.approvalComments = "";

    this.props.dialog.prompt({
      content: (
        <div>
          <Typography
            variant="h6"
            component="h5"
            style={{ marginBottom: "20px" }}
          >
            Please insert comments for the requested changes:
          </Typography>

          <label style={{ color: "black" }}>Approval comments: </label>

          <TextField
            multiline
            type="text"
            onChange={(event) =>
              this.onApprovalCommentsChange(event.target.value)
            }
            style={{
              width: "320px",
              marginTop: "8px",
            }}
          />
        </div>
      ),
      buttons: [
        {
          label: "Save",
          action: this.saveAction.bind(this),
        },
        {
          label: "Cancel",
        },
      ],
    });
  }

  saveAction() {
    const trimmedApprovalComments = this.approvalComments.trim();

    if (!trimmedApprovalComments) {
      return;
    }

    this.props
      .mutate({
        variables: {
          ticket_event_id: this.props.id,
          approval_comments: trimmedApprovalComments,
        },
      })
      .then(() => {
        this.props.reloadData();
      })
      .catch((error) => error && handleMutationError(error));
  }

  render() {
    return (
      <Button
        style={{
          backgroundColor: "#6774A2",
          color: "white",
          minWidth: "140px",
          height: "36px",
          fontSize: "13px",
          fontWeight: 500,
        }}
        onClick={() => this.requestChanges()}
      >
        Request Changes
      </Button>
    );
  }
}

const withRequestChangesMutation = graphql<MutationResult, Props>(
  gql`
    mutation RequestTicketEventChanges(
      $ticket_event_id: ID!
      $approval_comments: String!
    ) {
      ticket_event_request_changes(
        ticket_event_id: $ticket_event_id
        approval_comments: $approval_comments
      ) {
        id
        name
        status
        external_reference
        approval_comments
      }
    }
  `
);

export default withRouter(
  withDialog(withRequestChangesMutation(TicketEventRequestChangesButton))
);
